import { render } from "./Recuse.vue?vue&type=template&id=56618867&scoped=true"
import script from "./Recuse.vue?vue&type=script&lang=js"
export * from "./Recuse.vue?vue&type=script&lang=js"

import "./Recuse.vue?vue&type=style&index=0&id=56618867&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56618867"]])

export default __exports__